module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"error":{"notHalfWidthText":"contains non-alphanumeric characters"}},"ja":{"error":{"notHalfWidthText":"に半角英数記号以外の文字が含まれています"}}}')
  delete Component.options._Ctor
}
